import React from 'react'
import styled from 'styled-components'
import Screen from './_Screen'
import {Wrapper, Title as Title_} from './Intro'
import PropagateLoader from 'react-spinners/PropagateLoader'

class Loading extends React.Component
	render: ()->
		<Screen {@props...}>
			<Wrapper>
				<Title>{"Please Wait..."}</Title>
				<Loader>
					<PropagateLoader color="#fac40b" />
				</Loader>
			</Wrapper>
		</Screen>


Title = styled(Title_)"""
	margin-top: 25px
"""

Loader = styled.div"""
	width: 30px
	margin: 40px auto 0
"""


export default Loading